export default {
  bluetooth_scan: "Scan with bluetooth device (if available)",
  scan: "Scan",
  nfc: "NFC",
  qr: "QR-Code",
  find_area: "Find area",
  find_item: "Find item",
  or: "or",
  title_scan: "Identify",
  title_associate: "Associate Identifier",
  title_propose: "Propose new Identify",
  title_verify: "Proof of Presence",
  subtitle_item: "<span class='text-info'>Item</span> {name}",
  subtitle_area: "<span class='text-info'>Area</span> {name}",
  subtitle_location: "<span class='text-info'>Location</span> {name}",
  error_routing: "Error trying to route to entity",
  identify_same_entity: "This identifier is already associated with the current entity",
}
